import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  minutes?: number;
  className?: string;
  showIcon?: boolean;
}
export function CountdownTimer({
  minutes = 17,
  className = '',
  showIcon = true
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(minutes * 60); // Convert to seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutesLeft = Math.floor(timeLeft / 60);
  const secondsLeft = timeLeft % 60;
  return <div className={`flex items-center font-bold ${className}`} data-id="element-7">
      {showIcon && <Clock className="w-4 h-4 mr-2 animate-pulse" data-id="element-8" />}
      <span className="tabular-nums" data-id="element-9">
        {String(minutesLeft).padStart(2, '0')}:
        {String(secondsLeft).padStart(2, '0')}
      </span>
    </div>;
}